/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MultiSelectDropdownComponent} from './multi-select-dropdown.component';
import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {LoadingSpinnerModule} from '../../../../loading/loading-spinner/loading-spinner.module';

@NgModule({
    declarations: [MultiSelectDropdownComponent],
    exports: [MultiSelectDropdownComponent],
    imports: [
        CommonModule,
        NgbDropdownModule,
        LoadingSpinnerModule
    ]
})
export class MultiSelectDropdownModule {
}
